module.exports = __webpack_public_path__ + "img/073686.4aafe036.png";